export default function (context, val) {
    context.commit('set_form', {
        ContragentID: val,
        ContragentName: context.getters.options_contragents.filter(i => {
            return i.value === val;
        })[0].label,
    });
    context.dispatch('change_PartnerLegalEntityId', context.getters.options_contragents.filter(i => {
        return i.value === val;
    })[0].legalId);
    context.dispatch('agreement_getCourse', val.code);
    context.dispatch('agreement_comment');
    context.dispatch('agreement_sums');
}